import React from "react";
import { Grid, Typography } from "@mui/material";
import { t } from "i18next";
import { FailedTransactionItemProps } from "../../../interfaces/CategoryTransactionInterface";


const FailedTransactionItem = (props : FailedTransactionItemProps) => {

    const { transactionItem, failedTransaction, getFlagStatus} = props;

    const getFromFlagStatus = () => {

        if(failedTransaction?.oldCategoryStatus!==null || failedTransaction?.oldCategoryStatus === 0){
            return getFlagStatus(failedTransaction?.oldCategoryStatus?.toString());
        }
        else if(failedTransaction?.oldCategory !== null){
            return getFlagStatus(transactionItem.publicFlag);
        }
        else 
            return "-";

    };

    return (
        <Grid container>
            <Grid container xs={12} sm={12} md={6} lg={4}>
                <Grid>
                    <Typography variant="body1">{"【"+t("category_management.from")+"】"}{t("category_management.category_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">&nbsp;：{failedTransaction?.oldCategory??(failedTransaction?.oldCategoryStatus!==null ? transactionItem.productCategory:"-" )}&nbsp;/&nbsp;</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">{t("category_management.publication_status")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">：{getFromFlagStatus()}</Typography>
                </Grid>
            </Grid>
            <Grid container xs={12} sm={12} md={6} lg={4}>  
                <Grid>
                    <Typography variant="body1">{"【"+t("category_management.to")+"】"}{t("category_management.category_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">&nbsp;：{failedTransaction?.newCategory ?? (transactionItem.oldCategoryStatus!==null ? transactionItem.productCategory:"-" )}&nbsp;/&nbsp;</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">{t("category_management.publication_status")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">：{getFlagStatus(failedTransaction?.categoryTo ? (failedTransaction?.categoryTo?.publicFlag?.toString()):(failedTransaction?.categoryFrom?.publicFlag?.toString()))??"-"}</Typography>
                </Grid>
            </Grid>
            <Grid container xs={12} sm={12} md={6} lg={3}>
                <Grid>
                    <Typography variant="body1">{t("category_management.time")} ：</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">{failedTransaction?.createdAt}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default FailedTransactionItem;